"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.IdeaStatusFilterWithHelp = exports.IdeaStatusFilter = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _IdeationFiltersBox = _interopRequireDefault(require("./IdeationFiltersBox"));

var _updateQueryFilters = require("@insided/destination/modules/Navigation/shared/updateQueryFilters");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'ideation-status-filter';
exports.cssAnchorName = cssAnchorName;

var IdeaStatusFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeaStatusFilter, _Component);

  var _super = _createSuper(IdeaStatusFilter);

  function IdeaStatusFilter() {
    var _this$props$selectedI;

    var _this;

    (0, _classCallCheck2.default)(this, IdeaStatusFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedIdeationStatus: (_this$props$selectedI = _this.props.selectedIdeationStatus) !== null && _this$props$selectedI !== void 0 ? _this$props$selectedI : null,
      selectedIdeationStatusBeforeFiltersApply: null,
      setPortal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSelectedIdeationStatus", function (newStatus) {
      _this.setState({
        selectedIdeationStatus: newStatus
      });

      _this.setQueryParams(newStatus);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePortalSetting", function (evt) {
      _this.setState(function (prevState) {
        return {
          selectedIdeationStatusBeforeFiltersApply: prevState.selectedIdeationStatus,
          setPortal: evt.detail.display
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(IdeaStatusFilter, [{
    key: "setQueryParams",
    value: // eslint-disable-next-line class-methods-use-this
    function setQueryParams(newStatus) {
      (0, _updateQueryFilters.updateQueryFilters)({
        ideationStatus: newStatus ? [newStatus] : null
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('filter', this.updatePortalSetting);
      window.addEventListener('resetFilters', function () {
        return _this2.setSelectedIdeationStatus(null);
      });
      window.addEventListener('revertFilters', function () {
        return _this2.setSelectedIdeationStatus(_this2.state.selectedIdeationStatusBeforeFiltersApply);
      });
      window.addEventListener('ideationStatusFilterRemoval', function () {
        return _this2.setSelectedIdeationStatus(null);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      window.removeEventListener('filter', this.updatePortalSetting);
      window.removeEventListener('resetFilters', function () {
        return _this3.setSelectedIdeationStatus(null);
      });
      window.removeEventListener('revertFilters', function () {
        return _this3.setSelectedIdeationStatus(_this3.state.selectedIdeationStatusBeforeFiltersApply);
      });
      window.removeEventListener('ideationStatusFilterRemoval', function () {
        return _this3.setSelectedIdeationStatus(null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var ideationStatuses = this.props.ideationStatuses;
      var setPortal = this.state.setPortal;
      return (0, _preact.h)("div", null, (0, _preact.h)(_IdeationFiltersBox.default, {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters', 'is-hidden-M'),
        ideationStatuses: ideationStatuses,
        selectedName: this.state.selectedIdeationStatus,
        onSelect: function onSelect(name) {
          _this4.setSelectedIdeationStatus(name);
        }
      }), Boolean(setPortal) && (0, _preact.h)(_preactPortal.default, {
        into: ".instant-search__results-wrapper-filters"
      }, (0, _preact.h)(_IdeationFiltersBox.default, {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters'),
        ideationStatuses: ideationStatuses,
        selectedName: this.state.selectedIdeationStatus,
        onSelect: function onSelect(name) {
          _this4.setSelectedIdeationStatus(name);
        }
      })));
    }
  }]);
  return IdeaStatusFilter;
}(_preact.Component);

exports.IdeaStatusFilter = IdeaStatusFilter;

var IdeaStatusFilterWithHelp = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(IdeaStatusFilterWithHelp, _Component2);

  var _super2 = _createSuper(IdeaStatusFilterWithHelp);

  function IdeaStatusFilterWithHelp() {
    var _this5;

    (0, _classCallCheck2.default)(this, IdeaStatusFilterWithHelp);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this5 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "state", {
      title: _this5.props.title
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "onChangeTitle", function (newTitle) {
      _this5.setState({
        title: newTitle
      }, function () {
        return _this5.props.onChange(_this5.state);
      });
    });
    return _this5;
  }

  (0, _createClass2.default)(IdeaStatusFilterWithHelp, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      return (0, _preact.h)("div", {
        className: ""
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Title",
        name: "title",
        placeholder: "Add a title",
        type: "text",
        onChange: function onChange(e) {
          _this6.onChangeTitle(e.target.value);
        },
        value: this.state.title
      }));
    }
  }]);
  return IdeaStatusFilterWithHelp;
}(_preact.Component);

exports.IdeaStatusFilterWithHelp = IdeaStatusFilterWithHelp;
var _default = IdeaStatusFilter;
exports.default = _default;